<template>
  <div>
    <form id="payment-form">
      <div id="payment-element">
      </div>
      <slot name="card-errors">
        <div id="card-errors" role="alert"></div>
      </slot>
      <button ref="submitButtonRef" type="submit" class="hide"></button>
    </form>
  </div>
</template>

<script>
import { loadStripeCheckout } from './load-checkout'
export default {
  name: 'StripeElements',
  props: {
    pk: {
      type: String,
      required: true,
    },
    amount: {
      type: Number,
      default: undefined,
    },
    clientSecret: {
      type: String,
      default: undefined,
    },
    stripeAccount: {
      type: String,
      default: undefined,
    },
    apiVersion: {
      type: String,
      default: undefined,
    },
    locale: {
      type: String,
      default: 'auto',
    },
  },
  data () {
    return {
      loading: false,
      stripe: null,
      elements: null,
      card: null,
    }
  },
  computed: {
    theClientSecret () {
      return this.clientSecret
    },
    appearance () {
      return {
        theme: 'flat',
        variables: {
          fontFamily: ' "Gill Sans", sans-serif',
          fontLineHeight: '1.5',
          borderRadius: '10px',
          colorBackground: '#F6F8FA',
          colorPrimaryText: '#262626',
        },
        rules: {
          '.Block': {
            backgroundColor: 'var(--colorBackground)',
            boxShadow: 'none',
            padding: '12px',
          },
          '.Input': {
            padding: '12px',
          },
          '.Input:disabled, .Input--invalid:disabled': {
            color: 'lightgray',
          },
          '.Tab': {
            padding: '10px 12px 8px 12px',
            border: 'none',
          },
          '.Tab:hover': {
            border: 'none',
            boxShadow: '0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 7px rgba(18, 42, 66, 0.04)',
          },
          '.Tab--selected, .Tab--selected:focus, .Tab--selected:hover': {
            border: 'none',
            backgroundColor: '#fff',
            boxShadow: '0 0 0 1.5px var(--colorPrimaryText), 0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 7px rgba(18, 42, 66, 0.04)',
          },
          '.Label': {
            fontWeight: '500',
          },
        },
      }
    },
    style () {
      return {
        base: {
          color: '#32325d',
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: 'antialiased',
          fontSize: '16px',
          '::placeholder': {
            color: '#0359a2',
          },
        },
        invalid: {
          color: '#fa755a',
          iconColor: '#fa755a',
        },
      }
    },
    form () {
      return document.getElementById('payment-form')
    },
  },
  methods: {
    submit () {
      this.$refs.submitButtonRef.click()
    },
    showError (error) {
      const errorElement = document.getElementById('card-errors')
      errorElement.textContent = error
    },
  },
  mounted () {
    this.$emit('loading', true)
    loadStripeCheckout(this.pk, 'v3', () => {
      const options = {
        stripeAccount: this.stripeAccount,
        apiVersion: this.apiVersion,
        locale: this.locale,
      }
      this.stripe = window.Stripe(this.pk, options)
      const appearance = this.appearance
      const clientSecret = this.theClientSecret
      this.elements = this.stripe.elements({ appearance, clientSecret })
      this.card = this.elements.create('payment', {
        layout: {
          type: 'accordion',
          defaultCollapsed: false,
          radios: true,
          spacedAccordionItems: false,
        },
        hidePostalCode: true,
        style: this.style,
      })

      this.card.mount('#payment-element')

      this.card.addEventListener('ready', () => {
        this.$emit('loading', false)
        this.$emit('element', false)
      })

      this.card.addEventListener('change', ({ error }) => {
        const displayError = document.getElementById('card-errors')
        if (error) {
          displayError.textContent = error.message
        } else {
          displayError.textContent = ''
        }
      })

      this.form.addEventListener('submit', async (event) => {
        this.$emit('loading', true)
        try {
          event.preventDefault()
          const data = {
            ...this.card,
          }
          if (this.amount) data.amount = this.amount
          if (this.theClientSecret === null) {
            this.showError('Client secret could not load. please retry!')
            this.$emit('loading', false)
            return
          }
          const elements = this.elements
          this.stripe.confirmPayment({
            elements,
            redirect: 'if_required',
          }).then((result) => {
            if (result.error) {
              this.showError(result.error.message)
              this.$emit('loading', false)
              this.$emit('error', result.error.message)
            } else {
              if (result.paymentIntent.status === 'succeeded') {
                this.$emit('payment', true, result)
                // TODO validate from webhook if payment is complete in case user close the browser
              }
            }
          })
        } catch (error) {
          this.$emit('loading', false)
          this.$emit('error', error)
        } finally {
          console.log('finally')
        }
      })
    })
  },
}
</script>

<style scoped>
.StripeElement {
  box-sizing: border-box;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}

.hide {
  visibility: hidden;
}
</style>
